<template>
  <div class="panel panel-info">
    <div class="panel-heading">
      <h4 class="panel-title">
        <i class="fa fa-book"></i>客户信息
        <span
          @click="$router.go(-1)"
          style="cursor: pointer;"
          title="返回"
          class="fa fa-chevron-circle-left pull-right"
          >返回</span
        >
      </h4>
    </div>
    <div class="panel-body">
      <div class="row">
        <form class="form-horizontal">
          <div class="col-sm-12">
            <div class="col-sm-6">
              <!-- 姓名 -->
              <div class="form-group">
                <label class="col-sm-2 control-label"
                  ><span class="required">*</span>姓名</label
                >
                <div class="col-sm-10">
                  <input
                    type="text"
                    v-model="model.name"
                    name="name"
                    v-validate="{ required: true, max: 50 }"
                    class="form-control"
                    data-vv-as="姓名"
                    placeholder=""
                  />
                  <span class="error_validate_msg"
                    ><em>{{ errors.first("name") }}</em></span
                  >
                </div>
              </div>

              <!--身份证号 -->
              <div class="form-group">
                <label class="col-sm-2 control-label"
                  ><span class="required">*</span>身份证号</label
                >
                <div class="col-sm-10">
                  <input
                    type="text"
                    v-model="model.sfzh"
                    name="sfzh"
                    v-validate="{ required: true, idcard: true, max: 50 }"
                    class="form-control"
                    data-vv-as="身份证号"
                    placeholder=""
                  />
                  <span class="error_validate_msg"
                    ><em>{{ errors.first("sfzh") }}</em></span
                  >
                </div>
              </div>

              <!--手机号 -->
              <div class="form-group">
                <label class="col-sm-2 control-label"
                  ><span class="required">*</span>手机号</label
                >
                <div class="col-sm-10">
                  <input
                    type="text"
                    v-model="model.sjh"
                    name="sjh"
                    v-validate="{ required: true, mobile: true, max: 50 }"
                    class="form-control"
                    data-vv-as="政治面貌"
                    placeholder=""
                  />
                  <span class="error_validate_msg"
                    ><em>{{ errors.first("sjh") }}</em></span
                  >
                </div>
              </div>

              <!-- 生日 -->
              <div class="form-group">
                <label class="col-sm-2 control-label"
                  ><span class="required">*</span>生日</label
                >
                <div class="col-sm-10">
                  <DateTimePicker
                    name="csrq"
                    v-model="model.csrq"
                    format="YYYY-MM-DD"
                    input-class="form-control"
                    style="width:250px"
                    :show-buttons="true"
                    clearable
                    v-validate="{ required: true, max: 50 }"
                    data-vv-as="生日"
                  ></DateTimePicker>
                  <span class="error_validate_msg"
                    ><em>{{ errors.first("csrq") }}</em></span
                  >
                </div>
              </div>

              <!-- 学历 -->
              <div class="form-group">
                <label class="col-sm-2 control-label"
                  ><span class="required">*</span>学历</label
                >
                <div class="col-sm-10">
                  <BootstrapCombobox
                    :data="xlList"
                    name="xl"
                    value-field="value"
                    text-field="text"
                    v-model="model.xl"
                    :formatOption="(xl) => xl.text"
                    v-validate="{ required: true, max: 50 }"
                    data-vv-as="学历"
                  ></BootstrapCombobox>

                  <span class="error_validate_msg"
                    ><em>{{ errors.first("xl") }}</em></span
                  >
                </div>
              </div>

              <!--性别-->
              <div class="form-group">
                <label class="col-sm-2 control-label"
                  ><span class="required">*</span>性别</label
                >
                <div class="col-sm-10">
                  <label class="radio-inline">
                    <input
                      type="radio"
                      name="xb"
                      v-model="model.xb"
                      id="inlineRadio1"
                      class="isDisabled"
                      v-validate="{ required: true }"
                      value="M"
                      data-vv-as="性别"
                    />男</label
                  >
                  <label class="radio-inline">
                    <input
                      type="radio"
                      name="xb"
                      v-model="model.xb"
                      id="inlineRadio2"
                      class="isDisabled"
                      value="F"
                    />女</label
                  >
                  <span class="error_validate_msg"
                    ><em>{{ errors.first("xb") }}</em></span
                  >
                </div>
              </div>

              <!--民族 -->
              <div class="form-group">
                <label class="col-sm-2 control-label"
                  ><span class="required">*</span>民族</label
                >
                <div class="col-sm-10">
                  <BootstrapCombobox
                    :data="mzList"
                    name="mz"
                    value-field="value"
                    text-field="text"
                    v-model="model.mz"
                    :formatOption="(mz) => mz.text"
                    v-validate="{ required: true, max: 50 }"
                    data-vv-as="民族"
                  ></BootstrapCombobox>
                  <span class="error_validate_msg"
                    ><em>{{ errors.first("mz") }}</em></span
                  >
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <!-- 注册批次 -->
              <div class="form-group">
                <label class="col-sm-2 control-label"
                  ><span class="required">*</span>注册批次</label
                >
                <div class="col-sm-10">
                  <BootstrapCombobox
                    :data="zcpcArr"
                    name="mz"
                    value-field="id"
                    text-field="mc"
                    v-model="model.zcpcId"
                    :formatOption="(zcpcId) => zcpcId.mc"
                    v-validate="{ required: true, max: 50 }"
                    data-vv-as="注册批次"
                  ></BootstrapCombobox>
                  <span class="error_validate_msg"
                    ><em>{{ errors.first("zcpcId") }}</em></span
                  >
                </div>
              </div>

              <!-- 注册点 -->
              <div class="form-group">
                <label class="col-sm-2 control-label"
                  ><span class="required">*</span>注册点</label
                >
                <div class="col-sm-10">
                  <BootstrapCombobox
                    :data="zcdArr"
                    name="zcdId"
                    value-field="id"
                    text-field="zcdmc"
                    v-model="model.zcdId"
                    :formatOption="(zcdId) => zcdId.zcdmc"
                    v-validate="{ required: true, max: 50 }"
                    data-vv-as="注册点"
                  ></BootstrapCombobox>
                  <span class="error_validate_msg"
                    ><em>{{ errors.first("zcdId") }}</em></span
                  >
                </div>
              </div>
              <!-- 招生点 -->
              <div class="form-group">
                <label class="col-sm-2 control-label"
                  ><span class="required">*</span>招生点</label
                >
                <div class="col-sm-10">
                  <BootstrapCombobox
                    :data="zsdArr"
                    name="zsdId"
                    value-field="id"
                    text-field="zsdmc"
                    v-model="model.zsdId"
                    :formatOption="(zsdId) => zsdId.zsdmc"
                    v-validate="{ required: true, max: 50 }"
                    data-vv-as="招生点"
                  ></BootstrapCombobox>

                  <span class="error_validate_msg"
                    ><em>{{ errors.first("zsdId") }}</em></span
                  >
                </div>
              </div>

              <!-- 学历类型 -->
              <div class="form-group">
                <label class="col-sm-2 control-label"
                  ><span class="required">*</span>学历类型</label
                >
                <div class="col-sm-10">
                  <BootstrapCombobox
                    :data="educationArr"
                    name="xllx"
                    value-field="value"
                    text-field="zsdmc"
                    v-model="model.xllx"
                    :formatOption="(xllx) => xllx.text"
                    v-validate="{ required: true, max: 50 }"
                    data-vv-as="学历类型"
                  ></BootstrapCombobox>

                  <span class="error_validate_msg"
                    ><em>{{ errors.first("xllx") }}</em></span
                  >
                </div>
              </div>
              <!-- 年度码 -->
              <div class="form-group">
                <label class="col-sm-2 control-label"
                  ><span class="required">*</span>年度码</label
                >
                <div class="col-sm-10">
                  <input
                    type="text"
                    v-model="model.ndm"
                    name="ndm"
                    v-validate="{ required: true,  max: 5 }"
                    class="form-control"
                    data-vv-as="年度码"
                    placeholder=""
                  />
                  <span class="error_validate_msg"
                    ><em>{{ errors.first("ndm") }}</em></span
                  >
                </div>
              </div>

              <!-- 学习形式 -->
              <div class="form-group">
                <label class="col-sm-2 control-label"
                  ><span class="required">*</span>学习形式</label
                >

                <div class="col-sm-10">
                  <BootstrapCombobox
                    :data="xxxsArr"
                    name="xxxsId"
                    value-field="id"
                    text-field="zsdmc"
                    v-model="model.xxxsId"
                    :formatOption="(xxxsId) => xxxsId.mc"
                    v-validate="{ required: true, max: 50 }"
                    data-vv-as="学习形式"
                  ></BootstrapCombobox>
                  <span class="error_validate_msg"
                    ><em>{{ errors.first("xxxsId") }}</em></span
                  >
                </div>
              </div>

              <!-- 主考学校 -->
              <div class="form-group">
                <label class="col-sm-2 control-label"
                  ><span class="required">*</span>主考学校</label
                >
                <div class="col-sm-10">
                  <BootstrapCombobox
                    :data="zkxxArr"
                    name="zkxxId"
                    value-field="zkxxId"
                    text-field="zkxxName"
                    v-model="model.zkxxId"
                    :formatOption="
                      (zkxx) => zkxx.zkxxCode + '-' + zkxx.zkxxName
                    "
                    v-validate="{ required: true, max: 50 }"
                    data-vv-as="主考学校"
                    @change="zyChange()"
                  ></BootstrapCombobox>

                  <span class="error_validate_msg"
                    ><em>{{ errors.first("zkxxId") }}</em></span
                  >
                </div>
              </div>

              <!-- 助学机构 -->
              <div class="form-group">
                <label class="col-sm-2 control-label"
                  ><span class="required">*</span>助学机构</label
                >

                <div class="col-sm-10">
                  <BootstrapCombobox
                    v-validate="{ required: true }"
                    data-vv-as="助学机构"
                    name="zxjgId"
                    :data="jgArr"
                    value-field="zxjgId"
                    text-field="zxjgName"
                    v-model="model.zxjgId"
                    :formatOption="
                      (zxjg) => zxjg.zxjgCode + '-' + zxjg.zxjgName
                    "
                    @change="zyChange()"
                  ></BootstrapCombobox>
                  <span class="error_validate_msg"
                    ><em>{{ errors.first("zxjgId") }}</em></span
                  >
                </div>
              </div>

              <!-- 专业 -->
              <div class="form-group">
                <label class="col-sm-2 control-label"
                  ><span class="required">*</span>专业</label
                >
                <div class="col-sm-10">
                  <BootstrapCombobox
                    :data="zyArr"
                    name="zy"
                    value-field="zycc"
                    text-field="zymc"
                    v-model="model.zyId"
                    :formatOption="(zy) => zy.zydm + '-' + zy.zymc"
                    v-validate="{ required: true, max: 50 }"
                    data-vv-as="专业"
                  ></BootstrapCombobox>
                  <span class="error_validate_msg"
                    ><em>{{ errors.first("zy") }}</em></span
                  >
                </div>
              </div>

              <!-- 班级 -->
              <div class="form-group">
                <label class="col-sm-2 control-label"
                  ><span class="required">*</span>班级</label
                >
                <div class="col-sm-10">
                  <BootstrapCombobox
                    :data="bjArr"
                    name="bjId"
                    value-field="id"
                    text-field="bjmc"
                    v-model="model.bjId"
                    :formatOption="(bjId) => bjId.bjmc  + '-' +bjId.bzrxm"
                    v-validate="{ required: true, max: 50 }"
                    data-vv-as="班级"
                  ></BootstrapCombobox>
                  <span class="error_validate_msg"
                    ><em>{{ errors.first("bjId") }}</em></span
                  >
                </div>
              </div>

              <!-- 准考证号 -->
              <div class="form-group">
                <label class="col-sm-2 control-label"
                  ><span class="required">*</span>准考证号</label
                >
                <div class="col-sm-10">
                  <input
                    type="text"
                    v-model="model.zkzh"
                    name="zkzh"
                    class="form-control"
                    placeholder=""
                    v-validate="{ required: true }"
                    data-vv-as="准考证号"
                  />
                  <span class="error_validate_msg"
                    ><em>{{ errors.first("zkzh") }}</em></span
                  >
                </div>
              </div>
            </div>
          </div>

          <!--保存-->
          <div class="col-sm-12 text-center">
            <div class="form-group">
              <button
                @click="save()"
                type="button"
                class="btn btn-primary btn-sm "
                style="margin-right:16px"
              >
                提交
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { XL } from "@/plugins/enums.js";
import { EducationType } from "@/plugins/enums.js";
export default {
  name: "ClientAllChange",
  components: {},
  data: function() {
    return {
      model: {
        name: null, //姓名
        sfzh: null, // 身份证
        sjh: null, // 手机
        csrq: null, //出生
        xl: null, //学历
        xb: null, //性别
        mz: null, //民族
        zcpcId: null, //注册批次id
        zcdId: null, //注册点id
        zsdId: null, //招生点id
        xllx: null, // 学历类型
        zkxxId: null, //主考学校id
        xxxsId: null, // 学习形式
        bjId: null, //班级id
        zkzh: null, //准考证号
        zyId: null, //专业id
        ndm: null, // 年度码
      },
      mzList: [], //民族
      xlList: [], //学历
      zsdArr: [], // 招生点
      zcdArr: [], // 注册点
      zcpcArr: [], // 注册批次
      bjArr: [], // 班级
      zkxxArr: [], // 主考学校
      jgArr: [], // 助学机构
      zyArr: [], // 专业
      xxxsArr: [], //学习形式
    };
  },
  computed: {},

  created: function() {
    this.$store.commit("setBreadcrumb", [
      { name: "自学考试" },
      { name: "客户管理" },
      { name: "意向客户" },
      { name: "客户转学生" },
    ]);
    this.$store.commit("setShowReturnBackBtn", true);
    this.educationArr = EducationType;

    //民族
    this.mzList = [
      { text: "汉族", value: "HAN" },
      { text: "蒙古族", value: "MONGOL" },
      { text: "回族", value: "HUI" },
      { text: "藏族", value: "TIBETAN" },
      { text: "维吾尔族", value: "UYGHUR" },
      { text: "苗族", value: "MIAO" },
      { text: "彝族", value: "YI" },
      { text: "壮族", value: "ZHUANG" },
      { text: "布依族", value: "BUYEI" },
      { text: "朝鲜族", value: "KOREAN" },
      { text: "满族", value: "MANCHU" },
      { text: "侗族", value: "DONG" },
      { text: "瑶族", value: "YAO" },
      { text: "白族", value: "BAI" },
      { text: "土家族", value: "TUJIA" },
      { text: "哈尼族", value: "HANI" },
      { text: "哈萨克族", value: "KAZAK" },
      { text: "傣族", value: "DAI" },
      { text: "黎族", value: "LI" },
      { text: "傈僳族", value: "LISU" },
      { text: "佤族", value: "VA" },
      { text: "畲族", value: "SHE" },
      { text: "高山族", value: "GAOSHAN" },
      { text: "拉祜族", value: "LAHU" },
      { text: "水族", value: "SUI" },
      { text: "东乡族", value: "DONGXIANG" },
      { text: "纳西族", value: "NAXI" },
      { text: "景颇族", value: "JINGPO" },
      { text: "柯尔克孜族", value: "KIRGIZ" },
      { text: "土族", value: "TU" },
      { text: "达斡尔族", value: "DAUR" },
      { text: "仫佬族", value: "MULAO" },
      { text: "羌族", value: "QIANG" },
      { text: "布朗族", value: "BLANG" },
      { text: "撒拉族", value: "SALAR" },
      { text: "毛南族", value: "MAONAN" },
      { text: "仡佬族", value: "GELAO" },
      { text: "锡伯族", value: "XIBE" },
      { text: "阿昌族", value: "ACHANG" },
      { text: "普米族", value: "PUMI" },
      { text: "塔吉克族", value: "TAJIK" },
      { text: "怒族", value: "NU" },
      { text: "乌孜别克族", value: "UZBEK" },
      { text: "俄罗斯族", value: "RUSSIANS" },
      { text: "鄂温克族", value: "EWENKI" },
      { text: "德昂族", value: "DEANG" },
      { text: "保安族", value: "BONAN" },
      { text: "裕固族", value: "YUGUR" },
      { text: "京族", value: "GIN" },
      { text: "塔塔尔族", value: "TATAR" },
      { text: "独龙族", value: "DERUNG" },
      { text: "鄂伦春族", value: "OROQEN" },
      { text: "赫哲族", value: "HEZHEN" },
      { text: "门巴族", value: "MONBA" },
      { text: "珞巴族", value: "LHOBA" },
      { text: "基诺族", value: "JINO" },
      { text: "其他", value: "OTHER" },
      { text: "外国血统中国籍人士", value: "FOREIGN_COUNTRY" },
    ];
    //学历
    this.xlList = XL;
    this.model.name = this.$route.query.name;
    this.model.sjh = this.$route.query.mobile;
    this.model.customerId = this.$route.query.id;
    this.zsdIdList();
    this.zcdIdList();
    this.zcpcIdList();
    this.bjIdList();
    this.jgIdList();
    this.zkxxIdList();
    this.xxxsList();
  },
  methods: {
    zyChange() {
      this.zyIdList();
    },

    // 学习形式下拉数据
    xxxsList() {
      this.$http
        .post("/htgl/biz/specialtyBackup/getBackXxxsList")
        .then((res) => {
          this.xxxsArr = res.data;
        });
    },
    //助学机构
    jgIdList() {
      let poUrl = "/htgl/biz/specialtyBackup/getZxjgList";
      this.$http.post(poUrl).then((res) => {
        if (res.data) {
          this.jgArr = res.data;
        }
      });
    },
    // 主考学校
    zkxxIdList() {
      let poUrl = "/htgl/biz/specialtyBackup/getZkxxList";
      this.$http.post(poUrl).then((res) => {
        if (res.data) {
          this.zkxxArr = res.data;
        }
      });
    },

    // 班级
    bjIdList() {
      let poUrl = "/htgl/sys/bj/cx";
      this.$http.post(poUrl, { size: 99999, zt: "OK" }).then((res) => {
        if (res.code == 0) {
          this.bjArr = res.data.records;
        }
      });
    },

    // 专业
    zyIdList() {
      let poUrl = "/htgl/biz/specialtyBackup/getZyList";
      this.$http
        .post(poUrl, {
          xxxsId: this.model.xxxsId,
          zkxxId: this.model.zkxxId,
          zxjgId: this.model.zxjgId,
        })
        .then((res) => {
          if (res.data) {
            this.zyArr = res.data;
          }
        });
    },

    // 注册批次
    zcpcIdList() {
      let poUrl = "/htgl/inf/zcpc/list";
      this.$http.post(poUrl).then((res) => {
        if (res.code == 0) {
          this.zcpcArr = res.data;
        }
      });
    },

    // 注册点
    zcdIdList() {
      let poUrl = "/htgl/biz/zcd/list";
      this.$http.post(poUrl).then((res) => {
        if (res.code == 0) {
          this.zcdArr = res.data;
        }
      });
    },
    // 招生点
    zsdIdList() {
      let poUrl = "/htgl/biz/zsd/list";
      this.$http.post(poUrl).then((res) => {
        if (res.code == 0) {
          this.zsdArr = res.data;
        }
      });
    },

    //保存
    save: function() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let poUrl = "/htgl/biz/intentionCustomer/turnStudent";
          this.$http.post(poUrl, this.model).then((res) => {
            if (res.code == 0) {
              this.$success("操作成功", () => {
                // 跳转列表页
                this.$router.push({
                  name: "ClientList",
                });
              });
            }
          });
        }
      });
    },
  },
};
</script>
<style scoped>
#mt {
  width: 183px;
}
#mt1 {
  width: 183px;
}
</style>
